// Get application wide colors
import colors from "@/assets/styles/colors.sass";

// Make sure colors are in hex format (see: https://code.visualstudio.com/api/references/theme-color#color-formats)
import Colors from "color"
Object.keys(colors).map(function (key, index) {
    colors[key] = Colors(colors[key]).hex();
});

// Define few colors used for the style
const background = colors['primary-light']
const foreground = colors['secondary']
const foregroundValues = colors['primary-dark']
const foregroundPonctuation = colors['primary']
const backgroundSelected = colors['secondary-light']
const foregroundSelected = colors['secondary']
const backgroundHightlight = background //colors['primary-lighter']  // Same content as selected

// Define the whole style
export default {
    base: "vs",
    inherit: true,
    rules: [            // https://github.com/Microsoft/vscode/blob/93028e44ea7752bd53e2471051acbe6362e157e9/src/vs/editor/standalone/common/themes.ts#L13
        { token: '', foreground: foreground, background: background },
        { token: 'invalid', foreground: colors['warning'] },
        { token: 'emphasis', fontStyle: 'italic' },
        { token: 'strong', fontStyle: 'bold' },

        { token: 'variable', foreground: foreground },
        { token: 'variable.predefined', foreground: foreground },
        { token: 'constant', foreground: foregroundValues },
        { token: 'comment', foreground: foregroundPonctuation },
        { token: 'number', foreground: foregroundValues },
        { token: 'number.hex', foreground: foregroundValues },
        { token: 'regexp', foreground: foregroundValues },
        { token: 'annotation', foreground: foregroundPonctuation },
        { token: 'type', foreground: foregroundPonctuation },

        { token: 'delimiter', foreground: foregroundPonctuation },
        { token: 'delimiter.html', foreground: foregroundPonctuation },
        { token: 'delimiter.xml', foreground: foregroundPonctuation },

        { token: 'tag', foreground: '800000' },
        { token: 'tag.id.jade', foreground: '4F76AC' },
        { token: 'tag.class.jade', foreground: '4F76AC' },
        { token: 'meta.scss', foreground: '800000' },
        { token: 'metatag', foreground: 'e00000' },
        { token: 'metatag.content.html', foreground: 'FF0000' },
        { token: 'metatag.html', foreground: '808080' },
        { token: 'metatag.xml', foreground: '808080' },
        { token: 'metatag.php', fontStyle: 'bold' },

        { token: 'key', foreground: foreground },
        { token: 'string.key.json', foreground: 'A31515' },
        { token: 'string.value.json', foreground: '0451A5' },

        { token: 'attribute.name', foreground: 'FF0000' },
        { token: 'attribute.value', foreground: '0451A5' },
        { token: 'attribute.value.number', foreground: '09885A' },
        { token: 'attribute.value.unit', foreground: '09885A' },
        { token: 'attribute.value.html', foreground: '0000FF' },
        { token: 'attribute.value.xml', foreground: '0000FF' },

        { token: 'string', foreground: 'A31515' },
        { token: 'string.html', foreground: '0000FF' },
        { token: 'string.sql', foreground: 'FF0000' },
        { token: 'string.yaml', foreground: '0451A5' },

        { token: 'keyword', foreground: '0000FF' },
        { token: 'keyword.json', foreground: '0451A5' },
        { token: 'keyword.flow', foreground: 'AF00DB' },
        { token: 'keyword.flow.scss', foreground: '0000FF' },

        { token: 'operator.scss', foreground: '666666' },
        { token: 'operator.sql', foreground: '778899' },
        { token: 'operator.swift', foreground: '666666' },
        { token: 'predefined.sql', foreground: 'FF00FF' },
    ],
    colors: {       // https://code.visualstudio.com/api/references/theme-color
        // 'errorForeground' // Overall foreground color for error messages. This color is only used if not overridden by a component.
        // 'focusBorder' // Overall border color for focused elements. This color is only used if not overridden by a component.
        'foreground': foreground,                       // Overall foreground color. This color is only used if not overridden by a component.

        // 'badge.background' // Badge background color. Badges are small information labels, e.g. for search results count.
        // 'badge.foreground' // Badge foreground color. Badges are small information labels, e.g. for search results count.

        // 'button.background' // Button background color.
        // 'button.foreground' // Button foreground color.
        // 'button.hoverBackground' // Button background color when hovering.

        // 'contrastActiveBorder' // An extra border around active elements to separate them from others for greater contrast.
        // 'contrastBorder' // An extra border around elements to separate them from others for greater contrast.

        // 'descriptionForeground' // Foreground color for description text providing additional information, for example for a label.

        // 'diffEditor.insertedTextBackground' // Background color for text that got inserted.
        // 'diffEditor.insertedTextBorder' // Outline color for the text that got inserted.
        // 'diffEditor.removedTextBackground' // Background color for text that got removed.
        // 'diffEditor.removedTextBorder' // Outline color for text that got removed.

        // 'dropdown.background' // Dropdown background.
        // 'dropdown.border' // Dropdown border.
        // 'dropdown.foreground' // Dropdown foreground.

        'editor.background': background,                            // Editor background color.
        // 'editor.findMatchBackground' // Color of the current search match.
        // 'editor.findMatchHighlightBackground' // Color of the other search matches.
        // 'editor.findRangeHighlightBackground' // Color the range limiting the search.
        'editor.foreground': foreground,                            // Editor default foreground color.
        // 'editor.hoverHighlightBackground' // Highlight below the word for which a hover is shown.
        // 'editor.inactiveSelectionBackground' // Color of the selection in an inactive editor.
        'editor.lineHighlightBackground': backgroundHightlight,     // Background color for the highlight of line at the cursor position.
        // 'editor.lineHighlightBorder' // Background color for the border around the line at the cursor position.
        // 'editor.rangeHighlightBackground' // Background color of highlighted ranges, like by quick open and find features.
        'editor.selectionBackground': backgroundSelected,           // Color of the editor selection.
        'editor.selectionForeground': foregroundSelected,           // Color of the selected text for high contrast.
        'editor.selectionHighlightBackground': backgroundHightlight,// Color for regions with the same content as the selection.
        // 'editor.wordHighlightBackground' // Background color of a symbol during read-access, like reading a variable.
        // 'editor.wordHighlightStrongBackground' // Background color of a symbol during write-access, like writing to a variable.

        'editorBracketMatch.background': foreground,                // Background color behind matching brackets
        'editorBracketMatch.border': "transparent",                 // Color for matching brackets boxes
        // 'editorCodeLens.foreground' // Foreground color of editor code lenses
        // 'editorCursor.foreground' // Color of the editor cursor.
        // 'editorError.border' // Border color of error squigglies in the editor.
        // 'editorError.foreground' // Foreground color of error squigglies in the editor.
        // 'editorGutter.background' // Background color of the editor gutter. The gutter contains the glyph margins and the line numbers.
        // 'editorHoverWidget.background' // Background color of the editor hover.
        // 'editorHoverWidget.border' // Border color of the editor hover.
        // 'editorIndentGuide.background' // Color of the editor indentation guides.
        'editorLineNumber.foreground': foreground,                  // Color of editor line numbers.
        // 'editorLink.activeForeground' // Color of active links.

        // 'editorMarkerNavigation.background' // Editor marker navigation widget background.
        // 'editorMarkerNavigationError.background' // Editor marker navigation widget error color.
        // 'editorMarkerNavigationWarning.background' // Editor marker navigation widget warning color.

        'editorOverviewRuler.border': foreground,                   // Color of the overview ruler border.
        'editorOverviewRuler.commonContentForeground': foreground,  // Common ancestor overview ruler foreground for inline merge-conflicts.
        'editorOverviewRuler.currentContentForeground': foreground, // Current overview ruler foreground for inline merge-conflicts.
        // 'editorOverviewRuler.incomingContentForeground' // Incoming overview ruler foreground for inline merge-conflicts.
        'editorRuler.foreground': foreground,                       // Color of the editor rulers.

        // 'editorSuggestWidget.background' // Background color of the suggest widget.
        // 'editorSuggestWidget.border' // Border color of the suggest widget.
        // 'editorSuggestWidget.foreground' // Foreground color of the suggest widget.
        // 'editorSuggestWidget.highlightForeground' // Color of the match highlights in the suggest widget.
        // 'editorSuggestWidget.selectedBackground' // Background color of the selected entry in the suggest widget.

        // 'editorWarning.border' // Border color of warning squigglies in the editor.
        // 'editorWarning.foreground' // Foreground color of warning squigglies in the editor.
        // 'editorWhitespace.foreground' // Color of whitespace characters in the editor.
        // 'editorWidget.background' // Background color of editor widgets, such as find/replace.
        // 'editorWidget.border' // Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget.

        'input.background': background,                             // Input box background.
        // 'input.border' // Input box border.
        'input.foreground': foreground,                             // Input box foreground.
        // 'input.placeholderForeground' // Input box foreground color for placeholder text.
        // 'inputOption.activeBorder' // Border color of activated options in input fields.

        // 'inputValidation.errorBackground' // Input validation background color for error severity.
        // 'inputValidation.errorBorder' // Input validation border color for error severity.
        // 'inputValidation.infoBackground' // Input validation background color for information severity.
        // 'inputValidation.infoBorder' // Input validation border color for information severity.
        // 'inputValidation.warningBackground' // Input validation background color for information warning.
        // 'inputValidation.warningBorder' // Input validation border color for warning severity.

        // 'list.activeSelectionBackground' // List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.
        // 'list.activeSelectionForeground' // List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.
        // 'list.dropBackground' // List/Tree drag and drop background when moving items around using the mouse.
        // 'list.focusBackground' // List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.
        // 'list.focusForeground' // List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.
        // 'list.highlightForeground' // List/Tree foreground color of the match highlights when searching inside the list/tree.
        // 'list.hoverBackground' // List/Tree background when hovering over items using the mouse.
        // 'list.hoverForeground' // List/Tree foreground when hovering over items using the mouse.
        // 'list.inactiveSelectionBackground' // List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.
        // 'list.inactiveSelectionForeground' // List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.

        // 'merge.border' // Border color on headers and the splitter in inline merge-conflicts.
        // 'merge.commonContentBackground' // Common ancester content background in inline merge-conflicts.
        // 'merge.commonHeaderBackground' // Common ancestor header background in inline merge-conflicts.
        // 'merge.currentContentBackground' // Current content background in inline merge-conflicts.
        // 'merge.currentHeaderBackground' // Current header background in inline merge-conflicts.
        // 'merge.incomingContentBackground' // Incoming content background in inline merge-conflicts.
        // 'merge.incomingHeaderBackground' // Incoming header background in inline merge-conflicts.

        // 'peekView.border' // Color of the peek view borders and arrow.
        // 'peekViewEditor.background' // Background color of the peek view editor.
        // 'peekViewEditor.matchHighlightBackground' // Match highlight color in the peek view editor.
        // 'peekViewEditorGutter.background' // Background color of the gutter in the peek view editor.
        // 'peekViewResult.background' // Background color of the peek view result list.
        // 'peekViewResult.fileForeground' // Foreground color for file nodes in the peek view result list.
        // 'peekViewResult.lineForeground' // Foreground color for line nodes in the peek view result list.
        // 'peekViewResult.matchHighlightBackground' // Match highlight color in the peek view result list.
        // 'peekViewResult.selectionBackground' // Background color of the selected entry in the peek view result list.
        // 'peekViewResult.selectionForeground' // Foreground color of the selected entry in the peek view result list.
        // 'peekViewTitle.background' // Background color of the peek view title area.
        // 'peekViewTitleDescription.foreground' // Color of the peek view title info.
        // 'peekViewTitleLabel.foreground' // Color of the peek view title.

        // 'pickerGroup.border' // Quick picker color for grouping borders.
        // 'pickerGroup.foreground' // Quick picker color for grouping labels.

        // 'progressBar.background' // Background color of the progress bar that can show for long running operations.

        // 'scrollbar.shadow' // Scrollbar shadow to indicate that the view is scrolled.
        // 'scrollbarSlider.activeBackground' // Slider background color when active.
        // 'scrollbarSlider.background' // Slider background color.
        // 'scrollbarSlider.hoverBackground' // Slider background color when hovering.

        // 'selection.background' // The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor.

        // 'textBlockQuote.background' // Background color for block quotes in text.
        // 'textBlockQuote.border' // Border color for block quotes in text.
        // 'textCodeBlock.background' // Background color for code blocks in text.
        // 'textLink.activeForeground' // Foreground color for active links in text.
        // 'textLink.foreground' // Foreground color for links in text.
        // 'textPreformat.foreground' // Foreground color for preformatted text segments.
        // 'textSeparator.foreground' // Color for text separators.

        // 'widget.shadow' // Shadow color of widgets such as find/replace inside the editor.
    }
}

